import { ApiRequest, ShowLoader } from "GlobalFunctions";
import getOrderDetails from "./getOrderDetails";
import { validateAndApplyCoupon } from "../../utils/couponValidator";
import { calculateTaxes } from "./CalculateTaxes";

export default function Coupons(props: any) {
    const { 
        page
    } = props;

    // Read from localStorage instead of summary
    const cart = JSON.parse(localStorage.getItem('cart') || '{}');
    

    if (cart.coupon_id && Number(cart.coupon_id) != 0) {
        hideCouponContainer();
    }

    configCoupon();
    return null
}

/*=============================
SET SUMMARY
=============================*/
const configCoupon = async () => {

    /*=============================
    HIDE TOASTS pc="toast-discount-ok" and pc="toast-discount-error"
    =============================*/
    hideToasts();


    const coupon_form = document.querySelector('[pc="discount-form"]');
    if (coupon_form) {
        //get coupon input
        const coupon_input = coupon_form.querySelector('input');
        //get button
        const coupon_button = coupon_form.querySelector('[pc="discount-submit"]');

        // Only add the event listener if it hasn't been added before
        if (coupon_button && !coupon_button.hasAttribute('data-has-listener')) {
            const handleCouponSubmit = async (e: Event) => {
                hideToasts();
                e.preventDefault();
                if (coupon_input) {
                    const coupon_code = coupon_input.value;
                    if (coupon_code !== "") {
                        ShowLoader(true);
                        await ApiRequest({
                            method: 'POST',
                            url: '/coupons/validateCoupon',
                            body: { 
                                coupon_code
                            },
                            setResponse: (response: any) => {
                                
                                if (response.status === "success") {
                                    
                                    validateAndApplyCoupon(response.coupon).then((validationResult: any) => {
                                        console.log('Coupon validation result:', validationResult);
                                        if (validationResult.status === "success") {
                                            showToast("success", coupon_code);
                                            coupon_form.classList.add('hidden');
                                            calculateTaxes(validationResult.cart)
                                        } else {
                                            showToast("error", coupon_code);
                                        }
                                    });
                                } else {
                                    showToast("error", coupon_code);
                                }
                            }
                        });
                        ShowLoader(false);
                    }
                }
            };
            
            // Add the event listener
            coupon_button.addEventListener("click", handleCouponSubmit);
            
            // Mark the button to prevent adding multiple listeners
            coupon_button.setAttribute('data-has-listener', 'true');
        }
    }
   
};

/*=============================
HIDE COUPON CONTAINER
=============================*/
const hideCouponContainer = () => {
    const coupon_form = document.querySelector('[pc="discount-wrapper"]');
    if (coupon_form) {
        coupon_form.classList.add('hidden');
    }
}


/*=============================
HIDE TOASTS
=============================*/
const hideToasts = () => {
    const toast_discount_ok = document.querySelector('[pc="toast-discount-ok"]');
    const toast_discount_error = document.querySelector('[pc="toast-discount-error"]');
    if (toast_discount_ok) {
        toast_discount_ok.classList.add('hidden');
    }
    if (toast_discount_error) {
        toast_discount_error.classList.add('hidden');
    }
}


const showToast = (type: string, coupon: string) => {
    const toast_discount_ok = document.querySelector('[pc="toast-discount-ok"]');
    const toast_discount_error = document.querySelector('[pc="toast-discount-error"]');
    if (type === "success") {
        if (toast_discount_ok) {
            toast_discount_ok.classList.remove('hidden');
        }
    } else {
        if (toast_discount_error) {
            toast_discount_error.classList.remove('hidden');
        }
    }
    /*=============================
    ADD INPUT VALUE TO TOAST toast-discount-code
    =============================*/
    if (type === "success") {
        const toast_container = document.querySelector('[pc="toast-discount-ok"]');
        const toast_discount_code = toast_container?.querySelector('[pc="toast-discount-code"]');
        if (toast_discount_code) {
            toast_discount_code.innerHTML = coupon;
        }
        
    }
    else{
        const toast_container = document.querySelector('[pc="toast-discount-error"]');
        const toast_discount_code = toast_container?.querySelector('[pc="toast-discount-code"]');
        if (toast_discount_code) {
            toast_discount_code.innerHTML = coupon;
        }
    }
}